import { render } from "./mask.vue?vue&type=template&id=98b7a5a4"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"

import "./mask.vue?vue&type=style&index=0&id=98b7a5a4&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/mask.vue'],['render',render],['__file',"mask.vue"]])

export default __exports__